import {event} from '../vendor/dynamicyield/dynamicyield.js';
import {parse} from '../smartpak/cookie.js';

const smartPrimeCookie = parse('SmartPrimeEligible', function(obj) {
    obj.SmartPrimeEligible = !!obj.SmartPrimeEligible && obj.SmartPrimeEligible.toLowerCase() === 'true';
});

event('SmartPrime', smartPrimeCookie);

export default smartPrimeCookie;
